/**
 * Sample data for a Tanzania safari operator. Used only when the Frappe bench
 * is not reachable, so the screens stay reviewable before install.
 */

const today = new Date();

function iso(offsetDays) {
	const date = new Date(today);
	date.setDate(date.getDate() + offsetDays);
	return date.toISOString().slice(0, 10);
}

export const dashboard = {
	kpis: {
		total_tours: 24,
		total_customers: 156,
		open_enquiries: 4,
		quotations: 32,
		confirmed_bookings: 18,
		total_revenue: 48750,
	},
	upcoming_tours: [
		{ name: "QT-2026-0031", tour_name: "Serengeti Migration Safari", package: "Serengeti", start_date: iso(4), status: "Confirmed", amount: 11041.5, currency: "USD" },
		{ name: "QT-2026-0029", tour_name: "Ngorongoro Explorer", package: "Ngorongoro", start_date: iso(9), status: "Confirmed", amount: 8460, currency: "USD" },
		{ name: "QT-2026-0028", tour_name: "Zanzibar Beach Extension", package: "Zanzibar", start_date: iso(12), status: "Quote", amount: 3250, currency: "USD" },
		{ name: "QT-2026-0026", tour_name: "Tarangire Family Safari", package: "Tarangire", start_date: iso(19), status: "Confirmed", amount: 6800, currency: "USD" },
		{ name: "QT-2026-0024", tour_name: "Kilimanjaro Machame Route", package: "Kilimanjaro", start_date: iso(26), status: "Quote", amount: 4120, currency: "USD" },
	],
	sales_overview: [
		{ month: "Apr", total: 21000 },
		{ month: "May", total: 26500 },
		{ month: "Jun", total: 24800 },
		{ month: "Jul", total: 33200 },
		{ month: "Aug", total: 41800 },
		{ month: "Sep", total: 48750 },
	],
	recent_bookings: [
		{ name: "QT-2026-0031", booking_no: "BK-2026-0018", booking_name: "Kevin Ross", customer_name: "Direct Profile", package: "Serengeti Migration Safari", amount: 11041.5, currency: "USD", status: "Confirmed" },
		{ name: "QT-2026-0030", booking_no: "BK-2026-0017", booking_name: "Michael Lee", customer_name: "One World Travel", package: "Ngorongoro Explorer", amount: 8460, currency: "USD", status: "Confirmed" },
		{ name: "QT-2026-0029", booking_no: "", booking_name: "Emma Davis", customer_name: "Jenman Safaris", package: "Zanzibar Extension", amount: 3250, currency: "USD", status: "Quote" },
		{ name: "QT-2026-0028", booking_no: "BK-2026-0015", booking_name: "Robert Wilson", customer_name: "Direct Profile", package: "Tarangire Family Safari", amount: 6800, currency: "USD", status: "Confirmed" },
		{ name: "QT-2026-0027", booking_no: "BK-2026-0014", booking_name: "Linda Garcia", customer_name: "Karibu Agents", package: "Kilimanjaro Machame", amount: 4120, currency: "USD", status: "Confirmed" },
		{ name: "QT-2026-0026", booking_no: "", booking_name: "Fredor Group", customer_name: "Direct Profile", package: "Serengeti Fly-in", amount: 2450, currency: "USD", status: "Cancelled" },
	],
	top_suppliers: [
		{ supplier: "Auric Air", supplier_name: "Auric Air", services: 12, bookings: 10 },
		{ supplier: "Serengeti River Camp", supplier_name: "Serengeti River Camp", services: 10, bookings: 8 },
		{ supplier: "Karibu Camps and Lodges", supplier_name: "Karibu Camps and Lodges", services: 9, bookings: 8 },
		{ supplier: "Tanzania National Parks Authority", supplier_name: "Tanzania National Parks Authority", services: 8, bookings: 7 },
		{ supplier: "Ngorongoro Serena Lodge", supplier_name: "Ngorongoro Serena Lodge", services: 6, bookings: 6 },
	],
	recent_activity: [
		{ doctype: "TP Booking", docname: "QT-2026-0032", full_name: "Misha Pattni", timestamp: iso(0), label: "New quotation created" },
		{ doctype: "Payment Entry", docname: "PE-2026-0044", full_name: "Accounts", timestamp: iso(0), label: "Payment received" },
		{ doctype: "Supplier", docname: "Auric Air", full_name: "Misha Pattni", timestamp: iso(-1), label: "Supplier updated" },
		{ doctype: "Customer", docname: "One World Travel", full_name: "Misha Pattni", timestamp: iso(-1), label: "New customer added" },
		{ doctype: "TP Package", docname: "TP-2026-00045", full_name: "Misha Pattni", timestamp: iso(-2), label: "Itinerary updated" },
	],
	user: { full_name: "Misha Pattni", roles: ["Sales User"] },
};

export const packages = [
	{
		name: "TP-2026-00045",
		package_name: "6 Nights Serengeti Safari",
		tour_code: "TP-2026-00045",
		status: "Active",
		tour_type: "International",
		category: "Safari",
		destination: "Serengeti",
		destination_country: "Tanzania",
		duration_days: 7,
		duration_nights: 6,
		start_date: iso(30),
		end_date: iso(36),
		currency: "USD",
		cost_price: 4500,
		selling_price: 5850,
		profit_amount: 1350,
		profit_percent: 23.1,
		max_pax: 12,
		available_seats: 8,
	},
	{
		name: "TP-2026-00044",
		package_name: "Ngorongoro Crater Explorer",
		tour_code: "TP-2026-00044",
		status: "Active",
		tour_type: "International",
		category: "Safari",
		destination: "Ngorongoro",
		destination_country: "Tanzania",
		duration_days: 4,
		duration_nights: 3,
		start_date: iso(20),
		end_date: iso(23),
		currency: "USD",
		cost_price: 2100,
		selling_price: 2820,
		profit_amount: 720,
		profit_percent: 25.5,
		max_pax: 8,
		available_seats: 5,
	},
	{
		name: "TP-2026-00043",
		package_name: "Zanzibar Beach Extension",
		tour_code: "TP-2026-00043",
		status: "Active",
		tour_type: "International",
		category: "Beach",
		destination: "Zanzibar",
		destination_country: "Tanzania",
		duration_days: 5,
		duration_nights: 4,
		start_date: iso(45),
		end_date: iso(49),
		currency: "USD",
		cost_price: 1250,
		selling_price: 1690,
		profit_amount: 440,
		profit_percent: 26,
		max_pax: 16,
		available_seats: 11,
	},
	{
		name: "TP-2026-00042",
		package_name: "Kilimanjaro Machame Route",
		tour_code: "TP-2026-00042",
		status: "Draft",
		tour_type: "International",
		category: "Climbing",
		destination: "Kilimanjaro",
		destination_country: "Tanzania",
		duration_days: 8,
		duration_nights: 7,
		start_date: iso(60),
		end_date: iso(67),
		currency: "USD",
		cost_price: 2400,
		selling_price: 3150,
		profit_amount: 750,
		profit_percent: 23.8,
		max_pax: 10,
		available_seats: 10,
	},
	{
		name: "TP-2026-00041",
		package_name: "Tarangire Family Safari",
		tour_code: "TP-2026-00041",
		status: "Active",
		tour_type: "Domestic",
		category: "Family",
		destination: "Tarangire",
		destination_country: "Tanzania",
		duration_days: 3,
		duration_nights: 2,
		start_date: iso(15),
		end_date: iso(17),
		currency: "USD",
		cost_price: 980,
		selling_price: 1340,
		profit_amount: 360,
		profit_percent: 26.9,
		max_pax: 6,
		available_seats: 2,
	},
];

export const packageDetail = {
	...packages[0],
	detailed_description:
		"Seven days across the Serengeti and Ngorongoro highlands timed for the Great Migration river crossings. Fly-in to Kogatende, four nights under canvas on the Mara River, then the crater floor before returning to Arusha.",
	special_notes: "Balloon safari is weather dependent and is confirmed 24 hours before the flight.",
	min_pax: 2,
	quotations: 2,
	total_bookings: 10,
	total_payments: 5000,
	lists: {
		highlights: [
			"Great Migration river crossings",
			"Ngorongoro Crater floor",
			"Balloon safari option",
			"Maasai village visit",
		],
		inclusions: [
			"Park and concession fees",
			"Full board accommodation",
			"4x4 safari vehicle with guide",
			"Domestic flights",
		],
		exclusions: ["International flights", "Travel insurance", "Visa fees", "Tips and gratuities"],
		tags: ["Safari", "Serengeti", "Migration", "Popular"],
	},
	days: [
		{ day_no: 1, day_date: iso(30), destination: "Arusha", activities: "Arrival and briefing", hotel: "Arusha Coffee Lodge", meals: "Dinner" },
		{ day_no: 2, day_date: iso(31), destination: "Serengeti", activities: "Fly to Kogatende, afternoon game drive", hotel: "Serengeti River Camp", meals: "All meals" },
		{ day_no: 3, day_date: iso(32), destination: "Serengeti", activities: "Full day migration game drive", hotel: "Serengeti River Camp", meals: "All meals" },
		{ day_no: 4, day_date: iso(33), destination: "Serengeti", activities: "Balloon safari and central Serengeti", hotel: "Serengeti River Camp", meals: "All meals" },
		{ day_no: 5, day_date: iso(34), destination: "Ngorongoro", activities: "Transfer to the highlands", hotel: "Ngorongoro Serena Lodge", meals: "All meals" },
		{ day_no: 6, day_date: iso(35), destination: "Ngorongoro", activities: "Crater floor game drive", hotel: "Ngorongoro Serena Lodge", meals: "All meals" },
		{ day_no: 7, day_date: iso(36), destination: "Arusha", activities: "Return to Arusha and departure", hotel: "", meals: "Breakfast" },
	],
	services: [
		{ day_no: 1, service_type: "FL", product: "Arusha to Serengeti Kogatende", option_code: "PR1004", supplier: "Auric Air", qty: 1, cost_rate: 308, sell_rate: 338.8 },
		{ day_no: 2, service_type: "AC", product: "Serengeti River Camp", option_code: "EXSUITE", supplier: "Serengeti River Camp", qty: 4, cost_rate: 1430, sell_rate: 1573 },
		{ day_no: 2, service_type: "VH", product: "Safari Vehicle Hire", option_code: "4X4LC", supplier: "Karibu Camps and Lodges", qty: 1, cost_rate: 2275, sell_rate: 2502.5 },
		{ day_no: 2, service_type: "PF", product: "Concession Fee Serengeti", option_code: "CFSER", supplier: "Tanzania National Parks Authority", qty: 2, cost_rate: 355, sell_rate: 355 },
		{ day_no: 2, service_type: "PF", product: "Entry Fee Serengeti", option_code: "EFSER", supplier: "Tanzania National Parks Authority", qty: 2, cost_rate: 415, sell_rate: 415 },
	],
	bookings: [
		{ name: "QT-2026-0031", booking_no: "BK-2026-0018", booking_name: "Kevin Ross", customer_name: "Direct Profile", travel_date: iso(45), agent_total: 11041.5, currency: "USD", status: "Confirmed" },
		{ name: "QT-2026-0030", booking_no: "BK-2026-0017", booking_name: "Michael Lee", customer_name: "One World Travel", travel_date: iso(52), agent_total: 8460, currency: "USD", status: "Confirmed" },
		{ name: "QT-2026-0029", booking_no: "", booking_name: "Emma Davis", customer_name: "Jenman Safaris", travel_date: iso(60), agent_total: 3250, currency: "USD", status: "Quote" },
	],
	payments: [
		{ name: "PE-2026-0044", posting_date: iso(-3), paid_amount: 2500, party: "Direct Profile", mode_of_payment: "Wire Transfer" },
		{ name: "PE-2026-0041", posting_date: iso(-9), paid_amount: 2500, party: "One World Travel", mode_of_payment: "Wire Transfer" },
	],
};

export const bookings = [
	{
		name: "QT-2026-0032",
		booking_no: "BK-2026-0018",
		booking_name: "Kevin Ross",
		customer: "Direct Profile",
		customer_name: "Direct Profile",
		consultant: "misha@karibu.co.tz",
		package: "6 Nights Serengeti Safari",
		travel_date: iso(45),
		end_date: iso(49),
		currency: "USD",
		total_pax: 2,
		total_cost: 9000,
		agent_total: 11041.5,
		margin_percent: 18.49,
		status: "Confirmed",
	},
	{
		name: "QT-2026-0031",
		booking_no: "",
		booking_name: "Fredor",
		customer: "One World Travel",
		customer_name: "One World Travel",
		consultant: "misha@karibu.co.tz",
		package: "Ngorongoro Crater Explorer",
		travel_date: iso(28),
		end_date: iso(31),
		currency: "USD",
		total_pax: 4,
		total_cost: 6800,
		agent_total: 8460,
		margin_percent: 19.6,
		status: "Quote",
	},
	{
		name: "QT-2026-0030",
		booking_no: "BK-2026-0017",
		booking_name: "6 Nights Safari",
		customer: "Jenman Safaris",
		customer_name: "Jenman Safaris",
		consultant: "misha@karibu.co.tz",
		package: "6 Nights Serengeti Safari",
		travel_date: iso(21),
		end_date: iso(27),
		currency: "USD",
		total_pax: 2,
		total_cost: 8200,
		agent_total: 10250,
		margin_percent: 20,
		status: "Confirmed",
	},
	{
		name: "QT-2026-0029",
		booking_no: "",
		booking_name: "Road Trip Katerina",
		customer: "Direct Profile",
		customer_name: "Direct Profile",
		consultant: "misha@karibu.co.tz",
		package: "Tarangire Family Safari",
		travel_date: iso(14),
		end_date: iso(16),
		currency: "USD",
		total_pax: 5,
		total_cost: 4900,
		agent_total: 6800,
		margin_percent: 27.9,
		status: "Quote",
	},
	{
		name: "QT-2026-0028",
		booking_no: "BK-2026-0015",
		booking_name: "One World Travel",
		customer: "One World Travel",
		customer_name: "One World Travel",
		consultant: "misha@karibu.co.tz",
		package: "Zanzibar Beach Extension",
		travel_date: iso(9),
		end_date: iso(13),
		currency: "USD",
		total_pax: 2,
		total_cost: 2450,
		agent_total: 3250,
		margin_percent: 24.6,
		status: "Completed",
	},
];

export const bookingDetail = {
	name: "QT-2026-0032",
	booking_no: "BK-2026-0018",
	booking_name: "Kevin Ross",
	status: "Confirmed",
	customer: "Direct Profile",
	customer_name: "Direct Profile",
	consultant: "Misha Pattni",
	package: "6 Nights Serengeti Safari",
	travel_date: iso(45),
	end_date: iso(49),
	currency: "USD",
	adults: 2,
	children: 0,
	infants: 0,
	total_pax: 2,
	total_cost: 9000,
	markup_amount: 2041.5,
	markup_percent: 22.68,
	total_retail: 11041.5,
	commission_percent: 0,
	commission_amount: 0,
	tax_amount: 1454.49,
	agent_total: 11041.5,
	margin_amount: 2041.5,
	margin_percent: 18.49,
	invoiced_amount: 0,
	received_amount: 0,
	to_be_invoiced: 11041.5,
	total_due: 0,
	notes: "Client requested an extra night in Arusha. Waiting for supplier confirmation.",
	passengers: [
		{ name: "pax1", pax_name: "Kevin Ross/Adult 01", pax_type: "Adult", nationality: "United States", passport_no: "P1234567", room_ref: "R1" },
		{ name: "pax2", pax_name: "Kevin Ross/Adult 02", pax_type: "Adult", nationality: "United States", passport_no: "P7654321", room_ref: "R1" },
	],
	rooms: [{ name: "room1", room_ref: "R1", room_type: "Twin", pax_names: "Kevin Ross/Adult 01, Kevin Ross/Adult 02", service_ref: "PR1004" }],
	services: [
		{
			name: "svc1",
			day_no: 1,
			sequence: 1,
			service_date: iso(45),
			location: "ARU",
			supplier: "Auric Air",
			product: "Arusha to Serengeti Kogatende",
			product_description: "Arusha to Serengeti Kogatende",
			option_code: "PR1004",
			service_type: "FL",
			time_from: "1000",
			time_to: "1230",
			service_status: "OK",
			supplier_confirmation: "AA-99231",
			price_code: "ST",
			apply_database_markup: 1,
			adults: 2,
			children: 0,
			infants: 0,
			qty: 1,
			ways: 1,
			nights: 0,
			room_config: "Pax Group",
			cost_rate_adult: 308,
			sell_rate_adult: 338.8,
			cost_override: 292,
			sell_override: 340,
			total_cost: 584,
			total_sell: 680,
			total_sell_calc: 680,
			tax_amount: 0,
			markup_percent: 16.44,
			voucher_no: "8285",
			voucher_status: "Not Printed",
			allocation_type: "Free Sell",
			pickup_date: iso(45),
			pickup_time: "08:30",
			pickup_point: "Arusha Coffee Lodge",
			dropoff_date: iso(45),
			dropoff_time: "12:30",
			dropoff_point: "Kogatende Airstrip",
			remarks: "Luggage limit 15kg soft bags",
			service_voucher_text: "",
			rate_voucher_text: "",
			notes: "",
		},
		{
			name: "svc2",
			day_no: 1,
			sequence: 2,
			service_date: iso(45),
			location: "SER",
			supplier: "Serengeti River Camp",
			product: "Serengeti River Camp",
			product_description: "Executive Suite",
			option_code: "EXSUITE",
			service_type: "AC",
			service_status: "OK",
			supplier_confirmation: "SRC-4412",
			price_code: "ST",
			apply_database_markup: 1,
			adults: 2,
			children: 0,
			infants: 0,
			qty: 1,
			ways: 0,
			nights: 4,
			room_config: "Twin",
			cost_rate_adult: 650,
			sell_rate_adult: 715,
			total_cost: 5200,
			total_sell: 5720,
			total_sell_calc: 5720,
			tax_amount: 916,
			markup_percent: 10,
			voucher_no: "8286",
			voucher_status: "Not Printed",
			allocation_type: "Allotment",
			allocation: "SRC-ALLOT",
			release_days: 21,
			remarks: "",
			notes: "",
		},
		{
			name: "svc3",
			day_no: 1,
			sequence: 3,
			service_date: iso(45),
			location: "ARU",
			supplier: "Karibu Camps and Lodges",
			product: "Safari Vehicle Hire",
			product_description: "Safari Vehicle Hire",
			option_code: "4X4LC",
			service_type: "VH",
			service_status: "OK",
			price_code: "ST",
			apply_database_markup: 1,
			adults: 0,
			children: 0,
			infants: 0,
			qty: 1,
			ways: 0,
			nights: 0,
			cost_rate_adult: 2275,
			sell_rate_adult: 2275,
			total_cost: 2275,
			total_sell: 2275,
			total_sell_calc: 2275,
			tax_amount: 364,
			markup_percent: 0,
			voucher_no: "8287",
			voucher_status: "Not Printed",
			remarks: "",
			notes: "",
		},
		{
			name: "svc4",
			day_no: 1,
			sequence: 4,
			service_date: iso(45),
			location: "SER",
			supplier: "Tanzania National Parks Authority",
			product: "Concession Fee Serengeti",
			product_description: "Concession Fee Serengeti",
			option_code: "CFSER",
			service_type: "PF",
			service_status: "OK",
			price_code: "ST",
			adults: 2,
			children: 0,
			infants: 0,
			qty: 1,
			nights: 0,
			ways: 0,
			cost_rate_adult: 355,
			sell_rate_adult: 355,
			total_cost: 710,
			total_sell: 710,
			total_sell_calc: 710,
			tax_amount: 113.6,
			markup_percent: 0,
			voucher_status: "Not Printed",
			remarks: "",
			notes: "",
		},
		{
			name: "svc5",
			day_no: 1,
			sequence: 5,
			service_date: iso(45),
			location: "SER",
			supplier: "Tanzania National Parks Authority",
			product: "Entry Fee Serengeti",
			product_description: "Entry Fee Serengeti",
			option_code: "EFSER",
			service_type: "PF",
			service_status: "OK",
			price_code: "ST",
			adults: 2,
			children: 0,
			infants: 0,
			qty: 1,
			nights: 0,
			ways: 0,
			cost_rate_adult: 415,
			sell_rate_adult: 415,
			total_cost: 830,
			total_sell: 830,
			total_sell_calc: 830,
			tax_amount: 132.8,
			markup_percent: 0,
			voucher_status: "Not Printed",
			remarks: "",
			notes: "",
		},
		{
			name: "svc6",
			day_no: 5,
			sequence: 1,
			service_date: iso(49),
			location: "SER",
			supplier: "Auric Air",
			product: "Serengeti Kogatende to Arusha",
			product_description: "Serengeti Kogatende to Arusha",
			option_code: "PR1005",
			service_type: "FL",
			time_from: "1330",
			time_to: "1600",
			service_status: "OK",
			price_code: "ST",
			adults: 2,
			children: 0,
			infants: 0,
			qty: 1,
			ways: 1,
			nights: 0,
			cost_rate_adult: 379.5,
			sell_rate_adult: 417.45,
			total_cost: 759,
			total_sell: 834.9,
			total_sell_calc: 834.9,
			tax_amount: 0,
			markup_percent: 10,
			voucher_status: "Not Printed",
			remarks: "",
			notes: "",
		},
	],
	invoices: [],
	payments: [],
};

export const customers = [
	{ name: "Direct Profile", customer_name: "Direct Profile", customer_group: "Direct", territory: "Tanzania", default_currency: "USD", email_id: "res@karibu.co.tz", mobile_no: "+255 754 000 111" },
	{ name: "One World Travel", customer_name: "One World Travel", customer_group: "Agent", territory: "United States", default_currency: "USD", email_id: "safari@oneworld.com", mobile_no: "+1 202 555 0143" },
	{ name: "Jenman Safaris", customer_name: "Jenman Safaris", customer_group: "Agent", territory: "South Africa", default_currency: "USD", email_id: "info@jenmansafaris.com", mobile_no: "+27 21 683 7826" },
	{ name: "Karibu Agents", customer_name: "Karibu Agents", customer_group: "Agent", territory: "Germany", default_currency: "EUR", email_id: "buchung@karibu-agents.de", mobile_no: "+49 30 1234 5678" },
];

export const suppliers = [
	{ name: "Auric Air", supplier_name: "Auric Air", supplier_group: "Airline", country: "Tanzania", default_currency: "USD", products: 12 },
	{ name: "Serengeti River Camp", supplier_name: "Serengeti River Camp", supplier_group: "Camp", country: "Tanzania", default_currency: "USD", products: 4 },
	{ name: "Karibu Camps and Lodges", supplier_name: "Karibu Camps and Lodges", supplier_group: "Lodge", country: "Tanzania", default_currency: "USD", products: 9 },
	{ name: "Tanzania National Parks Authority", supplier_name: "Tanzania National Parks Authority", supplier_group: "Park Authority", country: "Tanzania", default_currency: "USD", products: 8 },
	{ name: "Ngorongoro Serena Lodge", supplier_name: "Ngorongoro Serena Lodge", supplier_group: "Lodge", country: "Tanzania", default_currency: "USD", products: 3 },
];

export const products = [
	{ name: "PROD-00001", product_name: "Arusha to Serengeti Kogatende", product_code: "CRA003", supplier: "Auric Air", service_type: "FL", location: "ARU", currency: "USD", default_markup_percent: 10, options: [{ option_code: "PR1004", option_name: "Arusha to Serengeti", time_from: "1000", time_to: "1230" }] },
	{ name: "PROD-00002", product_name: "Serengeti River Camp", product_code: "SRC001", supplier: "Serengeti River Camp", service_type: "AC", location: "SER", currency: "USD", default_markup_percent: 10, options: [{ option_code: "EXSUITE", option_name: "Executive Suite", room_type: "Double" }] },
	{ name: "PROD-00003", product_name: "Safari Vehicle Hire", product_code: "KCL010", supplier: "Karibu Camps and Lodges", service_type: "VH", location: "ARU", currency: "USD", default_markup_percent: 10, options: [{ option_code: "4X4LC", option_name: "4x4 Land Cruiser" }] },
	{ name: "PROD-00004", product_name: "Concession Fee Serengeti", product_code: "TANAPA-CF", supplier: "Tanzania National Parks Authority", service_type: "PF", location: "SER", currency: "USD", default_markup_percent: 0, options: [{ option_code: "CFSER", option_name: "Concession Fee" }] },
	{ name: "PROD-00005", product_name: "Entry Fee Serengeti", product_code: "TANAPA-EF", supplier: "Tanzania National Parks Authority", service_type: "PF", location: "SER", currency: "USD", default_markup_percent: 0, options: [{ option_code: "EFSER", option_name: "Entry Fee" }] },
];

export const rates = [
	{ name: "RATE-00001", product: "Arusha to Serengeti Kogatende", option_code: "PR1004", price_code: "ST", valid_from: iso(-180), valid_to: iso(540), currency: "USD", basis: "Per Person Per Way", cost_adult: 308, sell_adult: 338.8, markup_percent: 10 },
	{ name: "RATE-00002", product: "Serengeti River Camp", option_code: "EXSUITE", price_code: "ST", valid_from: iso(-180), valid_to: iso(540), currency: "USD", basis: "Per Person Per Night", cost_adult: 650, sell_adult: 715, markup_percent: 10 },
	{ name: "RATE-00003", product: "Safari Vehicle Hire", option_code: "4X4LC", price_code: "ST", valid_from: iso(-180), valid_to: iso(540), currency: "USD", basis: "Per Unit", cost_adult: 2275, sell_adult: 2275, markup_percent: 0 },
	{ name: "RATE-00004", product: "Concession Fee Serengeti", option_code: "CFSER", price_code: "ST", valid_from: iso(-180), valid_to: iso(540), currency: "USD", basis: "Per Person", cost_adult: 355, sell_adult: 355, markup_percent: 0 },
];

export const invoices = [
	{ name: "INV-2026-0012", customer: "Direct Profile", customer_name: "Direct Profile", posting_date: iso(-4), due_date: iso(10), currency: "USD", grand_total: 11041.5, outstanding_amount: 6041.5, status: "Partly Paid", tp_booking: "QT-2026-0032" },
	{ name: "INV-2026-0011", customer: "One World Travel", customer_name: "One World Travel", posting_date: iso(-12), due_date: iso(2), currency: "USD", grand_total: 8460, outstanding_amount: 0, status: "Paid", tp_booking: "QT-2026-0030" },
	{ name: "INV-2026-0010", customer: "Jenman Safaris", customer_name: "Jenman Safaris", posting_date: iso(-20), due_date: iso(-6), currency: "USD", grand_total: 3250, outstanding_amount: 3250, status: "Overdue", tp_booking: "QT-2026-0029" },
];

export const payments = [
	{ name: "PE-2026-0044", party: "Direct Profile", party_name: "Direct Profile", posting_date: iso(-3), paid_amount: 5000, currency: "USD", mode_of_payment: "Wire Transfer", reference_no: "SWIFT-88213", tp_booking: "QT-2026-0032" },
	{ name: "PE-2026-0041", party: "One World Travel", party_name: "One World Travel", posting_date: iso(-9), paid_amount: 8460, currency: "USD", mode_of_payment: "Wire Transfer", reference_no: "SWIFT-88120", tp_booking: "QT-2026-0030" },
	{ name: "PE-2026-0038", party: "Karibu Agents", party_name: "Karibu Agents", posting_date: iso(-18), paid_amount: 4120, currency: "EUR", mode_of_payment: "Credit Card", reference_no: "CC-4410", tp_booking: "QT-2026-0027" },
];

export const masters = {
	locations: [
		{ name: "ARU", code: "ARU", location_name: "Arusha" },
		{ name: "SER", code: "SER", location_name: "Serengeti" },
		{ name: "NGO", code: "NGO", location_name: "Ngorongoro" },
		{ name: "TAR", code: "TAR", location_name: "Tarangire" },
		{ name: "ZNZ", code: "ZNZ", location_name: "Zanzibar" },
	],
	service_types: [
		{ name: "AC", code: "AC", service_type_name: "Accommodation", category: "Accommodation", is_accommodation: 1 },
		{ name: "FL", code: "FL", service_type_name: "Flights", category: "Flight" },
		{ name: "TR", code: "TR", service_type_name: "Transfers", category: "Transfer" },
		{ name: "VH", code: "VH", service_type_name: "Vehicle Hire", category: "Vehicle Hire" },
		{ name: "PF", code: "PF", service_type_name: "Park Fees", category: "Park Fee" },
	],
	price_codes: [
		{ name: "ST", code: "ST", description: "Standard" },
		{ name: "RK", code: "RK", description: "Rack" },
		{ name: "NET", code: "NET", description: "Net Agent" },
	],
	currencies: [{ name: "USD" }, { name: "EUR" }, { name: "TZS" }, { name: "GBP" }],
};
